import {useEffect, useState} from 'react'

export function useUnityScriptLoader(baseUrl, unityVersion) {
    const [scriptLoaded, setScriptLoaded] = useState(false)
    const [deviceType, setDeviceType] = useState('Desktop')
    const [scriptError, setScriptError] = useState(null)

    useEffect(() => {
        let type = 'Desktop'
        const c = document.createElement('canvas')
        const gl = c.getContext('webgl')
        const gl2 = c.getContext('webgl2')
        if ((gl && gl.getExtension('WEBGL_compressed_texture_astc')) ||
            (gl2 && gl2.getExtension('WEBGL_compressed_texture_astc'))) {
            type = 'Mobile'
        }

        let script
        const src = `${baseUrl}/${unityVersion}/${type}/Build/build.loader.js`

        if (document.querySelector(`script[src="${src}"]`) && typeof window.createUnityInstance === 'function') {
            console.log('Unity instance creator available before script load')
            setScriptLoaded(true)
            setDeviceType(type)

            return
        }

        script = document.createElement('script')
        script.src = src
        script.async = true

        script.onload = () => {
            if (typeof window.createUnityInstance === 'function') {
                console.log('Unity instance creator available after script load')
                setScriptLoaded(true)
                setDeviceType(type)
            } else {
                setScriptError('Unity instance creator not available after script load')
            }
        }

        script.onerror = () => {
            setScriptError(`Failed to load Unity script version: ${unityVersion}`)
        }

        document.body.appendChild(script)

        return () => {
            if (script?.parentNode) {
                document.body.removeChild(script)
            }

            setScriptLoaded(false)
            setScriptError(null)
        }
    }, [baseUrl, unityVersion])

    return {scriptLoaded, scriptError, deviceType}
}
